
import React, { useState } from "react";
import { 
  Table, 
  TableBody, 
  TableCaption, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "@/components/ui/table";
import { Card } from "@/components/ui/card";
import { UserWithProfile } from "@/models/user";
import EditUserDialog from "./EditUserDialog";
import DeleteUserDialog from "./DeleteUserDialog";
import UserTableRow from "./UserTableRow";
import UserTableEmptyState from "./UserTableEmptyState";

interface UsersTableProps {
  users: UserWithProfile[];
  isLoading: boolean;
  onUserUpdated: () => void;
  onUserDeleted: () => void;
}

const UsersTable: React.FC<UsersTableProps> = ({ 
  users, 
  isLoading, 
  onUserUpdated, 
  onUserDeleted 
}) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<UserWithProfile | null>(null);

  const handleEditUser = (user: UserWithProfile) => {
    setSelectedUser(user);
    setEditDialogOpen(true);
  };

  const handleDeleteClick = (user: UserWithProfile) => {
    setSelectedUser(user);
    setDeleteDialogOpen(true);
  };

  return (
    <>
      <Card>
        <div className="relative overflow-x-auto">
          <Table>
            <TableCaption>Lista de usuarios del sistema</TableCaption>
            <TableHeader>
              <TableRow>
                <TableHead>Nombre</TableHead>
                <TableHead>Correo electrónico</TableHead>
                <TableHead>Rol</TableHead>
                <TableHead className="text-right">Acciones</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading || users.length === 0 ? (
                <UserTableEmptyState isLoading={isLoading} />
              ) : (
                users.map((user) => (
                  <UserTableRow 
                    key={user.id} 
                    user={user} 
                    onEditUser={handleEditUser}
                    onDeleteUser={handleDeleteClick}
                  />
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </Card>
      
      {selectedUser && (
        <>
          <EditUserDialog
            open={editDialogOpen}
            onOpenChange={setEditDialogOpen}
            user={selectedUser}
            onUserUpdated={onUserUpdated}
          />
          
          <DeleteUserDialog
            open={deleteDialogOpen}
            onOpenChange={setDeleteDialogOpen}
            user={selectedUser}
            onUserDeleted={onUserDeleted}
          />
        </>
      )}
    </>
  );
};

export default UsersTable;
